<template>
  <div class="address">
    <div class="tableConBox">
      <div class="tableTem">
        <div class="HSpace1"></div>
        <div class="searchBox flex flex-align-center">
          <div class="searchCon clearfix">
            <div class="left searchBtn">
              <button type="button" @click="showUpBox(null)">
                <i class="el-icon-plus"></i>添加租赁商品
              </button>
            </div>
          </div>
        </div>
        <div class="HSpace2"></div>
        <div class="tableBox">
          <div class="tableBoxScroll">
            <table class="titleTable">
              <tr>
                <th style="width: 10%; text-align: left; padding-left: 1%">
                  商品图片
                </th>
                <th style="width: 15%; text-align: left; padding-left: 1%">
                  商品名称
                </th>
                <th style="width: 15%; text-align: left; padding-left: 1%">
                  分类名称
                </th>
                <th style="width: 10%; text-align: left; padding-left: 1%">
                  排序值
                </th>
                <th style="width: 10%; text-align: left; padding-left: 1%">
                  总库存数
                </th>
                <!-- <th style="width: 10%; text-align: left; padding-left: 1%">
                  押金
                </th> -->
                <th style="width: 10%; text-align: left; padding-left: 1%">
                  展示至PC
                </th>
                <th style="width: 10%; text-align: left; padding-left: 1%">
                  允许购买
                </th>
                <th style="width: 10%; text-align: right; padding-right: 5%">
                  操作
                </th>
              </tr>
            </table>
            <div class="scrollBox">
              <div class="scroll">
                <table class="conTable" :class="{ overLengthTable: listData.length > 10 }">
                  <tr v-for="item in listData">
                    <td style="width: 10%; text-align: left; padding-left: 1%">
                      <div class="img_box" v-if="item.id">
                        <img style="width: 50px; height: 50px;margin: 20px 0;" :src="item.image + '?x-oss-process=image/resize,l_300'
                          " alt="" />
                      </div>
                    </td>
                    <td style="width: 15%; text-align: left; padding-left: 1%">
                      <span v-text="item.name"></span>
                    </td>
                    <td style="width: 15%; text-align: left; padding-left: 1%">
                      <span v-text="item.productTypeName"></span>
                    </td>
                    <td style="width: 10%; text-align: left; padding-left: 1%">
                      <span v-text="item.queue"></span>
                    </td>
                    <td style="width: 10%; text-align: left; padding-left: 1%">
                      <span v-text="item.totalCount"></span>
                    </td>
                    <!-- <td style="width: 10%; text-align: left; padding-left: 1%">
                      <span v-text="item.amount"></span>
                    </td> -->
                    <td style="width: 10%; text-align: left; padding-left: 1%">
                      <span v-if="item.id" :style="item.showPcEnabled ? 'color:green' : 'color:red'
                        ">{{ item.showPcEnabled ? "是" : "否" }}</span>
                    </td>
                    <td style="width: 10%; text-align: left; padding-left: 1%">
                      <span v-if="item.id" :style="item.buyEnabled ? 'color:green' : 'color:red'">{{ item.buyEnabled ?
                        "是" : "否" }}</span>
                    </td>

                    <td style="width: 10%; text-align: right; padding-right: 5%">
                      <span title="修改" style="margin: 0 2%; cursor: pointer" v-if="item.id" @click="showUpBox(item)"><i
                          class="iconfont icon-bianji"></i></span>
                      <span title="删除" style="cursor: pointer" @click="delItem(item)" v-if="item.id"><i
                          class="iconfont icon-icon1460188478041"></i></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="'添加/编辑租赁商品'" :visible.sync="addAddrBtn" width="80%">
      <div class="msgWrap">
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>商品名称</span>
            <input type="text" class="itemInput" v-model="form.name" placeholder="请输入名称" />
          </div>
        </div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>商品分类</span>
            <el-select style="padding-left: 10px" placeholder="请选择分类" v-model="form.productTypeId" class="itemSelect">
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="msgWrap">
        <!-- <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>押金金额</span>
            <input
              type="text"
              class="itemInput"
              v-model="form.amount"
              placeholder="请输入"
            />
          </div>
        </div> -->
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>排序值</span>
            <input type="text" class="itemInput" v-model="form.queue" placeholder="请输入" />
          </div>
        </div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>总库存数量</span>
            <input type="number" class="itemInput" v-model="form.totalCount" placeholder="请输入" />
          </div>
        </div>
      </div>
      <div class="msgWrap">
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>展示到PC</span>
            <div style="width: 70%">
              <el-radio class="radio left itemRadio" v-model="form.showPcEnabled" :label="true">是</el-radio>
              <el-radio class="radio left itemRadio" v-model="form.showPcEnabled" :label="false">否</el-radio>
            </div>
          </div>
        </div>
        <div class="msgBox clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>是否能购买</span>
            <div style="width: 70%">
              <el-radio class="radio left itemRadio" v-model="form.buyEnabled" :label="true">是</el-radio>
              <el-radio class="radio left itemRadio" v-model="form.buyEnabled" :label="false">否</el-radio>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="msgWrap">
        <div class="msgBox clearfix">
          <div class="msgItem" style="justify-content: normal; margin-bottom: 0px">
            <span class="itemName"><i>*</i>商品押金</span>
            <div class="cont">
              <el-button type="text" @click.stop="modifyExtra('add')">添加数据</el-button>
            </div>
          </div>
        </div>
        <div class="msgBox clearfix">
          <div class="msgItem" style="justify-content: normal; margin-bottom: 0px"></div>
        </div>
      </div>
      <div class="cont-list">
        <el-table :data="form.extras" v-if="showRule" border style="width: 100%">
          <el-table-column type="index" label="序号" width="70"></el-table-column>
          <el-table-column prop="name" width="120" label="押金金额">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.amount" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="计费方式" width="150">
            <template slot-scope="scope">
              <el-select v-model="scope.row.ruleId" @change="(e) => changeItemRule(e, scope.row)" placeholder="请选择">
                <el-option v-for="item in ruleList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="适用区域（仅针对PC客户端）">
            <template slot-scope="scope">
              <div style="width:100%;">
                <el-select style="width:100%;" v-model="scope.row.options" multiple placeholder="不选择区域，则默认为全场...">
                  <el-option v-for="item in regionData" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="PC默认规则" width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.defaultPcRule" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="80">
            <template slot-scope="scope"><el-button type="text"
                @click.stop="modifyExtra('del', scope.$index)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div class="msgWrap">
        <div class="msgBox img_box clearfix">
          <div class="left msgItem clearfix">
            <span class="itemName"><i>*</i>商品图片</span>
            <div class="left img" style="width: 100%">
              <div class="img_item left">
                <img v-if="form.image" ref="goodsImg" :src="form.image + '?x-oss-process=image/resize,l_300'" alt="" />
                <span v-if="form.image" @click="delImg" class="del-img">X</span>
              </div>
              <div class="img_up_btn left">
                <i class="iconfont icon-xiazai"></i>
                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg" class="pcImgFile" title="选择图片" />
                <input type="file" accept="image/*" @change="coverImg" class="mobileImgFile" />
              </div>
              <div class="clear"></div>
              <div class="uploadImgTip">
                支持JPG、JPEG、PNG格式，单张大小不超过5M，建议尺寸 600*600 px
              </div>
            </div>
          </div>
        </div>
        <div class="msgBox img_box clearfix"></div>
      </div>
      <!--  -->
      <span slot="footer" class="dialog-footer">
        <button type="button" @click="addAddrBtn = false" class="cancel">
          取消
        </button>
        <button type="button" @click="addFn" class="save">保存</button>
      </span>
    </el-dialog>
    <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId"
      @closeImgCrop="showCrop = false" @getCropImgBase="getCropImgBase"></img-crop>
  </div>
</template>

<script type="text/javascript">
import imgCrop from "@/components/imgCrop/imgCrop.vue";
import { API_BASE_URL } from "./../../../../urlConfig/index";

export default {
  props: ["pageSize", "curStoreId"],
  components: { imgCrop },
  data() {
    return {
      regionData: [],
      showRule: true,
      typeList: [],
      form: {
        id: 0,
        name: "",
        image: "",
        queue: 0,
        productTypeId: "",
        productTypeName: "",
        totalCount: "",
        amount: "",
        enabled: true,
        showPcEnabled: true,
        buyEnabled: true,
        extras: [],
      },
      specs: [],
      defaultSpec: "",
      autoSpec: "",
      dialogVisible: false,
      addAddrBtn: false, //添加地址按钮
      listData: [], //地址列表
      addr: "", //收货地址
      name: "", //姓名
      phone: "",
      userName: "", //用户手机号
      id: "",
      coverImgMaxSize: 20 * 1024 * 1024, // 图片最大字节数
      oldImgBase64: "", // 原图base64
      showCrop: false, // 控制图片裁剪显示隐藏
      curCropW: 600, // 裁剪宽度
      curCropH: 600, // 裁剪高度
      infoload: false, // loading
      ruleList: [],
    };
  },

  methods: {
    getRegion() {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "region/list",
          method: "POST",
          data: {
            storeId: this.$route.params.id
          }
        }).then(res => {
          this.regionData = res.data;
          resolve();
        });
      }).catch((err) => {
        reject();
      });
    },
    //
    changeItemRule(e, item) {
      console.log("e", e);
      this.ruleList.forEach((it) => {
        if (it.id == e) {
          item.ruleName = it.name;
        }
      });
      console.log("item", item);
      this.$forceUpdate();
    },
    modifyExtra(type, index) {
      let extras = JSON.parse(JSON.stringify(this.form.extras));
      if (type == "add") {
        let obj = {
          ruleName: "",
          ruleId: "",
          amount: "",
          options: [],
          defaultPcRule: false,
        };
        if (extras && Array.isArray(extras)) {
          extras.push(obj);
        } else {
          extras = [obj];
        }
      } else {
        extras.splice(index, 1);
      }
      this.$set(this.form, "extras", extras);
    },
    // 删除修改商品时的图片
    delImg() {
      this.$refs.goodsImg.src =
        "https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png";
      this.form.image =
        "https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png";
    },
    coverImg: function (e) {
      let reader = new FileReader();
      let that = this;
      let fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过20MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过20MB",
          customClass: "error",
        });
        return false;
      }

      reader.onload = (function (file) {
        return function (e) {
          let that2 = this; // 缓存当前this
          let img = new Image();
          img.src = this.result;
          img.onload = function () {
            let imgBase64 = that2.result; //获得图片的base64的数据

            // 判断是否是移动端设备
            let sUserAgent = navigator.userAgent.toLowerCase();
            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            let bIsAndroid = sUserAgent.match(/android/i) == "android";
            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (
              bIsIpad ||
              bIsIphoneOs ||
              bIsMidp ||
              bIsUc7 ||
              bIsUc ||
              bIsAndroid ||
              bIsCE ||
              bIsWM
            ) {
              that.mobileUploadImg(imgBase64);
            } else {
              that.oldImgBase64 = imgBase64;
              that.showCrop = true;
            }
          };
          $(".pcImgFile").val("");
          $(".mobileImgFile").val("");
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    // 移动端上传图片
    mobileUploadImg: function (imgBase64) {
      this.infoload = true;
      this.$http
        .post(
          API_BASE_URL + "v1/image/json/upload?storeId=" + this.curStoreId,
          { file: imgBase64 }
        )
        .then((res) => {
          this.newGoods.imageURL = res.data.path;
          this.infoload = false;
        })
        .catch(() => {
          this.infoload = false;
        });
    },
    // 获得裁剪后图片base64
    getCropImgBase: function (imgUrl) {
      this.form.image = imgUrl;
    },
    modifySpec(type, index) {
      let specs = JSON.parse(JSON.stringify(this.specs));
      if (type == "add") {
        if (!String(this.autoSpec).trim()) {
          this.$message({
            message: "请输入规格名称",
            customClass: "error",
          });
          return;
        }
        specs.push(this.autoSpec);
        this.autoSpec = "";
      } else if (type == "del") {
        specs.splice(index, 1);
      }
      this.specs = specs;
    },
    //
    //删除地址
    delItem(item) {
      this.$confirm("此操作将删除该商品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http({
            url: "delete/lease",
            method: "POST",
            data: {
              id: item.id,
            },
          }).then((res) => {
            this.getData();
          });
        })
        .catch(() => { });
    },
    //新建或更新地址
    addFn(id) {
      if (!this.form.name) {
        this.$message({
          message: "请填写名称",
          customClass: "error",
        });
        return;
      }
      if (!this.form.productTypeId) {
        this.$message({
          message: "请选择分类",
          customClass: "error",
        });
        return;
      }
      // if (!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.form.amount)) {
      //   this.$message({
      //     message: "金额格式有误",
      //     customClass: "error",
      //   });
      //   return;
      // }
      if (!/^[1-9][0-9]*$/.test(this.form.totalCount)) {
        this.$message({
          message: "数量输入有误",
          customClass: "error",
        });
        return true;
      }
      if (!this.form.image) {
        this.$message({
          message: "请上传商品图片",
          customClass: "error",
        });
        return;
      }
      //
      if (
        !this.form.extras ||
        !Array.isArray(this.form.extras) ||
        !this.form.extras.length
      ) {
        this.$message({
          message: "请添加商品押金",
          customClass: "error",
        });
        return;
      } else {
        let flag = false;
        let hasDefaultPcRule = 0;
        for (let i = 0; i < this.form.extras.length; i++) {
          if (!this.form.extras[i].ruleId) {
            this.$message({
              message: "请选择押金规则",
              customClass: "error",
            });
            flag = true;
            break;
          }
          if (
            !/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(
              this.form.extras[i].amount
            )
          ) {
            this.$message({
              message: "押金金额格式有误",
              customClass: "error",
            });
            flag = true;
            break;
          }
          if (this.form.extras[i].defaultPcRule) {
            hasDefaultPcRule++;
          }
        }
        if (flag) {
          return;
        }
        if (!hasDefaultPcRule || hasDefaultPcRule > 1) {
          this.$message({
            message: "默认规则必须选择一项",
            customClass: "error",
          });
          return;
        }
      }
      //
      let productTypeName;
      if (this.form.productTypeId) {
        this.typeList.forEach((it) => {
          if (it.id == this.form.productTypeId) {
            productTypeName = it.name;
          }
        });
      }
      // 
      if (
        this.form.extras &&
        Array.isArray(this.form.extras) &&
        this.form.extras.length
      ) {
        this.form.extras.forEach(it => {
          // 
          if (Array.isArray(it.options) && it.options.length) {
            let tempArr = [];
            it.options.forEach(ite => {
              this.regionData.forEach(regionItem => {
                if (regionItem.id == ite) {
                  tempArr.push({
                    regionId: ite,
                    regionName: regionItem.name,
                  });
                }
              });
            });
            it.options = tempArr;
          }
          // 
        });
      }
      // 
      this.$http({
        url: "edit/lease",
        method: "POST",
        data: {
          ...this.form,
          productTypeName,
          id: this.form.id ? this.form.id : 0,
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.getData();
        this.addAddrBtn = false;
        this.name = "";
        this.id = "";
        this.defaultSpec = "";
        this.specs = [];
        this.$message({
          message: "操作成功！",
          customClass: "success",
        });
      });
    },
    showUpBox(item) {
      if (item) {
        if (!item.extras || !Array.isArray(item.extras)) {
          item.extras = [];
        } else {
          // try {
          //   for (let i = 0; i < item.extras.length; i++) {
          //     console.log("extras", item.extras[i]);
          //     item.extras[i] = JSON.parse(item.extras[i]);
          //     if (item.extras[i]) {
          //       item.extras[i].ruleId = Number(item.extras[i].ruleId);
          //     }
          //   }
          // } catch (error) {
          //   console.log("error", error);
          // }
        }
        this.form = { ...item };
        this.showRule = false;
        setTimeout(() => {
          this.showRule = true;
        }, 250);
        console.log("this.form", this.form);
      } else {
        this.form = {
          id: 0,
          name: "",
          image: "",
          queue: 0,
          productTypeId: "",
          productTypeName: "",
          totalCount: "",
          amount: "",
          enabled: true,
          showPcEnabled: true,
          buyEnabled: true,
          extras: [],
        };
      }
      this.addAddrBtn = true;
    },
    getData() {
      this.$http({
        url: "lease/product/list",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        try {
          if (res.data && Array.isArray(res.data) && res.data.length) {
            res.data.forEach((it) => {
              if (it.extras && Array.isArray(it.extras) && it.extras.length) {
                it.extras.forEach((ite, ind) => {
                  if (String(ite.options) == "null" || !ite.options) {
                    ite.options = [];
                  }
                  if (Array.isArray(ite.options) && ite.options.length) {
                    let tempArr = [];
                    ite.options.forEach(item => {
                      tempArr.push(item.regionId);
                    });
                    ite.options = tempArr;
                  }
                  if (typeof ite == "string") {
                    it.extras[ind] = JSON.parse(ite);
                  }
                });
              }
            });
          }
        } catch (error) {
          console.log("error", error);
        }
        console.log(res.data);
        this.listData = res.data;
        if (this.listData.length < this.pageSize) {
          for (
            let i = 0, len = this.pageSize - this.listData.length;
            i < len;
            i++
          ) {
            this.listData.push({});
          }
        }
      });
    },
    getCates() {
      this.$http({
        url: "lease/type/list",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.typeList = res.data;
      });
    },
    getRules() {
      this.$http({
        url: "rule-list",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        this.ruleList = res.data;
      });
    },
  },
  created: function () {
    this.userName = localStorage.getItem("username");
    for (let i = 0; i < this.pageSize; i++) {
      this.listData.push({});
    }
  },
  activated: function () {
    this.getCates();
    this.getRules();
    this.getData();
    this.getRegion();
  },
};
</script>
<style lang="scss">
@import "../../../../../static/css/common.scss";
@import "../../../tableTemplate/tableTem.scss";
@import "../../../tableTemplate/el-dialog.scss";
@import "./index.scss";

.msgWrap {
  display: flex;
  padding: 10px 20px;

  .msgBox {
    width: 50%;
    display: flex;
    align-items: top;
    white-space: nowrap;

    .msgItem {
      display: flex;
      justify-content: space-between;

      .itemName {
        width: 30% !important;
        padding: 0;
        padding-right: 10px;
      }

      .itemInput {
        padding-left: 10px;
        display: flex;
        justify-content: flex-end;

        input {
          width: 95%;
        }
      }
    }

    &.full {
      width: 100%;
      display: inline-block;

      .msgItem {
        width: 100%;
        display: flex;
        position: relative;

        .itemName {
          width: 10%;
          margin-right: 10px;
        }

        .cont {
          width: 100%;

          .cont-list {
            width: 100%;
          }
        }
      }

      .img {}
    }
  }
}

.cont-list {
  padding: 15px 26px;
}
</style>
<style>
.cell {
  word-break: normal;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// index.vue?ed4bb644